import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FinishProService } from '../../services/finish-pro.service';
import { Environment } from '../../../models/environment';
import { PersonalizationsService } from '../../../base/services/personalizations/personalizations.service';
import { LoadingProService } from '../../services/loading-pro.service';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit, AfterViewInit {
    public subtitleText: string;

    public titleText: string;

    public messageText: string;

    public callbackText: string;

    _transParam: boolean = false;

    notifMessage: string = '';

    urlCallback: string = '';

    environment: Environment;

    constructor(
        private _finishProService: FinishProService,
        private _personalization: PersonalizationsService,
        private _loadingPro: LoadingProService,
      ) {
          this.environment = this._personalization.sendEnv;
        }

    public ngOnInit(): void {
        this.subtitleText = 'signaturit_pro.error.subtitle';
        this.titleText = 'signaturit_pro.error.title';
        this.messageText = 'signaturit_pro.error.message';
        this.callbackText = 'signaturit_pro.error.callback';
        this.loadCallbackConfig();
    }

    ngAfterViewInit(): void {
        this.addMessageError(this._finishProService.operationRequest?.error);
        this._loadingPro.setLoader(false);
        this._loadingPro.setNextOperationLoader(false);
    }

    addMessageError(message: any): void {
        this.notifMessage = `${message?.error?.error?.code}: ${message?.error?.error?.message}. TraceID: ${message?.error?.error?.traceid}`;
    }

    loadCallbackConfig(): void {
      this.urlCallback = this._finishProService.urlCallbackKO;
      if(this.environment.features.autoRedirect && this.urlCallback){
        document.location.href = this.urlCallback;
      }
    }

    redirectCallback(url: string): void {
      document.location.href = url;
    }

}
